module.exports = __webpack_public_path__ + "static/img/welcomePage.1116750a.jpg";